import { Link } from 'react-router-dom';
import type { Drama } from '@/types/drama';

interface RankingListProps {
  dramas: Drama[];
  wide?: boolean;
}

function formatViews(views: number) {
  if (views >= 10000) return `${(views / 10000).toFixed(1)}万`;
  return `${views}`;
}

export default function RankingList({ dramas, wide = false }: RankingListProps) {
  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
      <ol className={wide ? 'grid grid-cols-1 gap-x-8 md:grid-cols-2' : 'flex flex-col'}>
        {dramas.map((d, i) => (
          <li key={d.id} className="border-b border-background-200 last:border-b-0">
            <Link to={`/detail/${d.id}`} className="group flex cursor-pointer items-center gap-3 py-3">
              <span
                className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-md font-heading text-sm font-bold ${
                  i < 3 ? 'bg-accent-500 text-background-50' : 'bg-background-200 text-foreground-700'
                }`}
              >
                {i + 1}
              </span>
              <span className="relative h-14 w-10 shrink-0 overflow-hidden rounded-md bg-primary-900">
                <img
                  src={d.poster}
                  alt={`${d.title} 剧集封面`}
                  title={`${d.title} 韩国伦理剧`}
                  className="h-full w-full object-cover object-top"
                />
              </span>
              <span className="min-w-0 flex-1">
                <span className="block truncate font-heading text-sm font-semibold text-foreground-950 transition-colors group-hover:text-primary-600">
                  {d.title}
                </span>
                <span className="mt-0.5 flex items-center gap-2 text-xs text-foreground-500">
                  <span className="inline-flex items-center gap-0.5 text-accent-600">
                    <i className="ri-star-fill text-[11px]" />
                    {d.rating.toFixed(1)}
                  </span>
                  <span>{d.genres[0]}</span>
                </span>
              </span>
              <span className="shrink-0 whitespace-nowrap text-xs text-foreground-500">{formatViews(d.views)}次</span>
            </Link>
          </li>
        ))}
      </ol>
    </div>
  );
}